var exports = {
  "kL": "x804f0401--32672a--container",
  "DD": "x804f0401--32672a--title",
  "VA": "x804f0401--32672a--subtitle",
  "x6": "x804f0401--32672a--button",
};

module.exports = exports;
